module.exports = __webpack_public_path__ + "img/gartenzaun.755033a7.webp";